import cloudPlanImage from 'IMAGE/homepage/video-record-bg.webp';
import cloudPlanMobileImage from 'IMAGE/homepage/video-record-bg-m.webp';
import simPlanImage from 'IMAGE/homepage/sim-plan-intro.webp';
import simPlanMobileImage from 'IMAGE/homepage/sim-plan-intro-m.webp';
import i18n from 'LANG';

export interface IProductIntroduction {
    [key: string]: string;
    type: 'cloud-plan'| 'sim-plan';
}

export const servicesList: IProductIntroduction[] = [
    {
        type: 'cloud-plan',
        title: i18n.t( 'homepage.videoRecordTitlePC' ) as string,
        subtitle: i18n.t( 'homepage.videoRecordSubTitle' ) as string,
        desc: i18n.t( 'homepage.videoRecordDes' ) as string,
        pcImageSrc: cloudPlanImage,
        mobileImageSrc: cloudPlanMobileImage
    },
    {
        type: 'sim-plan',
        title: i18n.t( 'homepage.sim.mainTitle' ) as string,
        subtitle: i18n.t( 'homepage.sim.subTitle' ) as string,
        desc: i18n.t( 'homepage.sim.description' ) as string,
        pcImageSrc: simPlanImage,
        mobileImageSrc: simPlanMobileImage
    }
];
